// extracted by mini-css-extract-plugin
export default {"root":"_2b1Ql","expanded":"_2RbEa"};